import { defineRecipe } from '@chakra-ui/react';

/** Selected gold comes from `accent`, not a hardcoded tint. */
export const optionTileRecipe = defineRecipe({
  base: {
    borderWidth: 'hairline',
    color: 'text',
    _focusVisible: {
      outline: '2px solid var(--chakra-colors-accent)',
      outlineOffset: '2px',
    },
  },
  variants: {
    shape: {
      tile: {
        borderRadius: 'xl',
        px: 3,
        py: 2.5,
        minH: '58px',
        textAlign: 'left',
      },
      pill: {
        borderRadius: 'full',
        px: 3,
        py: 1.5,
        fontSize: 'sm',
        fontWeight: 'semibold',
        textAlign: 'center',
      },
    },
    selected: {
      true: {
        borderColor: 'accent',
        bg: 'accent/16',
      },
      false: {
        borderColor: 'border',
      },
    },
  },
  compoundVariants: [
    {
      shape: 'tile',
      selected: false,
      css: { bg: 'bg/90' },
    },
    {
      shape: 'pill',
      selected: false,
      css: { bg: 'transparent', color: 'textMuted' },
    },
  ],
  defaultVariants: {
    shape: 'tile',
    selected: false,
  },
});
